import React, { useState, useEffect } from 'react';
import { getToken } from '../services/keycloak/authService';
import MFAVerificationModal from '../ui/MFAVerificationModal';
import LoadingScreen from './LoadingScreen';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const MFAGate = ({ children }) => {
  const [mfaRequired, setMfaRequired] = useState(false);
  const [checking, setChecking] = useState(true);
  const [showVerificationModal, setShowVerificationModal] = useState(false);

  useEffect(() => {
    checkMFARequirement();
  }, []);

  const checkMFARequirement = async () => {
    try {
      const token = getToken();
      if (!token) {
        setChecking(false);
        return;
      }

      // Check if already verified in this session
      const mfaVerified = sessionStorage.getItem('mfa_verified');
      const mfaVerifiedAt = sessionStorage.getItem('mfa_verified_at');

      // Verification valid for 8 hours
      if (mfaVerified === 'true' && mfaVerifiedAt) {
        const verifiedTime = parseInt(mfaVerifiedAt);
        const now = Date.now();
        const eightHours = 8 * 60 * 60 * 1000;

        if (now - verifiedTime < eightHours) {
          setChecking(false);
          return;
        }
      }

      // Check MFA status from backend
      const response = await fetch(`${API_URL}/mfa/status`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        console.error('Failed to check MFA status');
        setChecking(false);
        return;
      }

      const data = await response.json();

      // If MFA is configured and user not verified this session, show verification modal
      if (data.mfaConfigured && mfaVerified !== 'true') {
        setMfaRequired(true);
        setShowVerificationModal(true);
      }

      setChecking(false);
    } catch (err) {
      console.error('Error checking MFA requirement:', err);
      setChecking(false);
    }
  };

  const handleVerified = () => {
    setShowVerificationModal(false);
    setMfaRequired(false);
  };

  if (checking) {
    return <LoadingScreen fullScreen={true} />;
  }

  return (
    <>
      {mfaRequired && (
        <MFAVerificationModal
          isOpen={showVerificationModal}
          onVerified={handleVerified}
          onCancel={null} // Don't allow cancel - MFA is required
        />
      )}
      {children}
    </>
  );
};

export default MFAGate;
